// Straight rip of `escape-string-regexp@2.0.0` because of compilation errors.

const matchOperatorsRegex = /[|\\{}()[\]^$+*?.-]/g;

export const escapeStringRegexp = string => {
  if (typeof string !== 'string') {
    throw new TypeError('Expected a string');
  }

  return string.replace(matchOperatorsRegex, '\\$&');
};
